/**
 * PGLP - COMPONENTE DE LÓGICA E INTERFACE DE SEGUNDA CAMADA (2FA)
 * ARQUIVO: AuthAcesso_2FA_Logic.jsx
 * STATUS: CONVERTIDO EM COCKPIT PARA TESTE DE INTEGRALIDADE
 * DIRETRIZ: NBR 14653-2 | SEGURANÇA AMBER
 * PROPRIETÁRIO: MARCUS VINICIUS PEREIRA FERRAZ
 */

import React from 'react';
import {
  LayoutDashboard, FileText, Users, Calendar,
  ShieldCheck, Search, Bell, TrendingUp
} from 'lucide-react';

// --- COMPONENTE DE CARD TÉCNICO (INTEGRAL) ---
const CardMetrica = ({ titulo, valor, subtexto, icone: Icone, cor }) => (
  <div className="bg-[#0A0A0A] border border-white/5 p-8 rounded-[3rem] hover:border-white/20 transition-all relative overflow-hidden shadow-2xl">
    <div className="flex justify-between items-start mb-6">
      <div className="p-4 rounded-2xl" style={{ backgroundColor: `${cor}15`, color: cor }}>
        <Icone size={28} strokeWidth={2.5} />
      </div>
      <span className="text-[8px] font-black text-slate-600 uppercase tracking-widest text-right">
        M-HERMOM<br />SOBERANO
      </span>
    </div>
    <h3 className="text-slate-500 text-[9px] font-black uppercase tracking-[0.3em] mb-2">
      {titulo}
    </h3>
    <div className="flex items-baseline gap-2">
      <span className="text-4xl font-black text-white italic">{valor}</span>
      <span className="text-green-500 text-[10px] font-black uppercase">{subtexto}</span>
    </div>
  </div>
);

const AuthAcesso_2FA = () => {
  // DADOS DE TESTE FORÇADOS (MARCUS ADMIN)
  const user = { name: 'MARCUS FERRAZ', role: 'MH_ADMIN', empresa: 'MONTE HERMOM' };
  const themeColor = '#a61a3a';

  return (
    <div className="flex min-h-screen bg-black overflow-hidden font-black text-slate-200 selection:bg-red-600">

      {/* SIDEBAR DE NAVEGAÇÃO */}
      <aside className="w-80 bg-[#050505] border-r border-white/5 flex flex-col p-8 z-20">
        <div className="mb-12">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 shadow-2xl">
            <span className="text-black text-2xl italic font-black">MH</span>
          </div>
          <p className="text-[8px] font-black uppercase tracking-[0.5em] text-white/30 mb-1">
            Portal de Gestão
          </p>
          <h2 className="text-lg italic font-black text-white uppercase tracking-tighter">
            {user.empresa}
          </h2>
        </div>

        <nav className="flex-1 space-y-4">
          <div
            className="flex items-center space-x-4 p-4 rounded-2xl bg-white/5 text-white border-l-4"
            style={{ borderColor: themeColor }}
          >
            <LayoutDashboard size={20} />
            <span className="text-[10px] uppercase tracking-widest font-black">
              Dashboard Amber
            </span>
          </div>
          <div className="flex items-center space-x-4 p-4 text-white/40 hover:text-white transition-all cursor-pointer">
            <FileText size={20} />
            <span className="text-[10px] uppercase tracking-widest font-black">
              Laudos Periciais
            </span>
          </div>
          <div className="flex items-center space-x-4 p-4 text-white/40 hover:text-white transition-all cursor-pointer">
            <Users size={20} />
            <span className="text-[10px] uppercase tracking-widest font-black">
              Peritos
            </span>
          </div>
          <div className="flex items-center space-x-4 p-4 text-white/40 hover:text-white transition-all cursor-pointer">
            <Calendar size={20} />
            <span className="text-[10px] uppercase tracking-widest font-black">
              Agenda
            </span>
          </div>
        </nav>

        <div className="mt-auto pt-8 border-t border-white/5">
          <div className="flex items-center space-x-4">
            <div className="w-10 h-10 rounded-full bg-slate-800 border border-white/10 flex items-center justify-center overflow-hidden">
              <img
                src="https://laudo.montehermom.com.br/assets/img/identidade/Rosto_mascote_Monte_hermom.png"
                alt="Mascote"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[10px] font-black text-white uppercase truncate">
                {user.name}
              </p>
              <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest truncate">
                {user.role}
              </p>
            </div>
          </div>
        </div>
      </aside>

      {/* ÁREA PRINCIPAL */}
      <main className="flex-1 overflow-y-auto">
        {/* HEADER */}
        <header className="sticky top-0 z-10 bg-black/80 backdrop-blur-xl border-b border-white/5 px-12 py-8 flex justify-between items-center">
          <div>
            <h1 className="text-2xl italic font-black text-white uppercase tracking-tighter">
              Cockpit Amber
            </h1>
            <p className="text-[9px] font-black text-slate-500 uppercase tracking-[0.4em] mt-1">
              Validação de Integralidade 2FA
            </p>
          </div>

          <div className="flex items-center gap-6">
            <button className="p-3 rounded-2xl bg-white/5 hover:bg-white/10 transition-all text-white/60 hover:text-white">
              <Search size={18} />
            </button>
            <button className="p-3 rounded-2xl bg-white/5 hover:bg-white/10 transition-all text-white/60 hover:text-white relative">
              <Bell size={18} />
              <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-red-600" />
            </button>
            <div className="flex items-center gap-3 px-4 py-2 rounded-2xl bg-white/5 border border-white/5">
              <ShieldCheck size={16} style={{ color: themeColor }} />
              <span className="text-[9px] font-black text-white uppercase tracking-widest">
                Sessão Segura
              </span>
            </div>
          </div>
        </header>

        {/* CONTEÚDO */}
        <div className="p-12 space-y-12">
          {/* TÍTULO DA SEÇÃO */}
          <div>
            <h2 className="text-4xl italic font-black text-white uppercase tracking-tighter mb-2">
              Visão Geral
            </h2>
            <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.4em]">
              Monitoramento em Tempo Real
            </p>
          </div>

          {/* GRID DE MÉTRICAS */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
            <CardMetrica
              titulo="Laudos Ativos"
              valor="42"
              subtexto="+12%"
              icone={FileText}
              cor="#a61a3a"
            />
            <CardMetrica
              titulo="Peritos Online"
              valor="18"
              subtexto="+3"
              icone={Users}
              cor="#2563eb"
            />
            <CardMetrica
              titulo="Vistorias Hoje"
              valor="07"
              subtexto="+2"
              icone={Calendar}
              cor="#10b981"
            />
            <CardMetrica
              titulo="Performance"
              valor="98%"
              subtexto="+5%"
              icone={TrendingUp}
              cor="#f59e0b"
            />
          </div>

          {/* PAINEL DE ATIVIDADE */}
          <div className="bg-[#0A0A0A] border border-white/5 p-10 rounded-[3rem] shadow-2xl">
            <div className="flex justify-between items-center mb-8">
              <div>
                <h3 className="text-xl italic font-black text-white uppercase tracking-tighter">
                  Atividade Recente
                </h3>
                <p className="text-[9px] font-black text-slate-500 uppercase tracking-[0.4em] mt-1">
                  Últimas 24 horas
                </p>
              </div>
              <div
                className="px-4 py-2 rounded-full text-[9px] font-black uppercase tracking-widest"
                style={{ backgroundColor: `${themeColor}15`, color: themeColor }}
              >
                Ao Vivo
              </div>
            </div>

            <div className="space-y-4">
              {[
                { hora: '14:32', evento: 'Laudo #2847 finalizado', tipo: 'Laudo', cor: '#10b981' },
                { hora: '14:18', evento: 'Vistoria agendada - Zona Sul', tipo: 'Agenda', cor: '#2563eb' },
                { hora: '13:55', evento: 'Novo perito credenciado', tipo: 'Perito', cor: '#f59e0b' },
                { hora: '13:20', evento: 'Documentação validada', tipo: 'Doc', cor: '#a61a3a' }
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-6 p-5 rounded-2xl bg-white/[0.02] border border-white/5 hover:bg-white/5 transition-all"
                >
                  <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest w-16">
                    {item.hora}
                  </span>
                  <div
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: item.cor }}
                  />
                  <span className="flex-1 text-[11px] font-black text-white uppercase tracking-wide">
                    {item.evento}
                  </span>
                  <span
                    className="text-[9px] font-black uppercase tracking-widest px-3 py-1 rounded-full"
                    style={{ backgroundColor: `${item.cor}15`, color: item.cor }}
                  >
                    {item.tipo}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* RODAPÉ SOBERANO */}
          <div className="text-center py-8 border-t border-white/5">
            <p className="text-[8px] font-black text-slate-700 uppercase tracking-[0.5em]">
              M-HERMOM SOBERANO © 2026 · NBR 14653-2 · AMBER SECURITY
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthAcesso_2FA;